/**
 * @typedef ActionIds
 * @property {string[]} welcomePromotion202111
 */

/** @type {Readonly<ActionIds>} */
const actionIds = {
  welcomePromotion202111: ['820072737539134574', '27437705923134354', '30eaedcf-f0b6-4e3a-ba79-8407bd88ff31', 'be82fe62-59d9-489d-a906-3b039ef53c7a'],
};

module.exports = actionIds;
